module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Container', {
    staticClass: "drag-container",
    attrs: {
      "group-name": _vm.groupName,
      "drag-class": _vm.dragClass,
      "should-accept-drop": _vm.getShouldAcceptDrop,
      "get-child-payload": _vm.getChildPayload,
      "non-drag-area-selector": _vm.nonDragAreaSelector,
      "drop-placeholder": _vm.dropPlaceholderOptions,
      "remove-on-drop-out": _vm.shouldRemoveOnDrop,
      "tag": _vm.tag,
      "lock-axis": _vm.lockAxis,
      "orientation": _vm.orientation,
      "behaviour": _vm.behaviour
    },
    on: {
      "drop": _vm.onDrop
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70087889","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/DragContainer.vue
// module id = 1940
// module chunks = 0